/* Priskel custom gallery behaviour.
   Part A - PDP gallery dots, mirroring the collection-card slider indicator.
   Part B - collection-card dot sync while swiping on touch devices.
   Neither replaces a theme component; both read/drive existing ones.
   Delete this file and its tag in snippets/scripts.liquid to remove. */

/* ---------- Part A: product page gallery dots ---------- */
(function () {
  if (window.__pkPdpDotsInit) return;
  window.__pkPdpDotsInit = true;

  var SLIDER = 'hdt-slider.hdt-medias-slider';

  function visibleSlides(slider) {
    return [].slice.call(slider.querySelectorAll('.hdt-slider__slide')).filter(function (el) {
      return el.closest('hdt-slider') === slider && !el.hasAttribute('hidden');
    });
  }

  function build(slider) {
    if (!slider) return;
    var main = slider.closest('.hdt-product-media__main') || slider.parentElement;
    if (!main) return;

    var slides = visibleSlides(slider);
    var existing = main.querySelector('.pk-pdp-dots');

    if (existing && existing.children.length === slides.length) return;
    if (existing) existing.parentNode.removeChild(existing);
    if (slides.length < 2) return;

    var wrap = document.createElement('div');
    wrap.className = 'pk-pdp-dots';
    wrap.setAttribute('data-pk-pdp-dots', '');

    slides.forEach(function (sl, i) {
      var d = document.createElement('span');
      d.className = 'pk-pdp-dot' + (sl.classList.contains('is-selected') ? ' is-active' : '');
      d.setAttribute('data-pk-pdp-dot', i);
      d.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof slider.goToIndex === 'function') slider.goToIndex(i);
      });
      wrap.appendChild(d);
    });

    if (getComputedStyle(main).position === 'static') main.style.position = 'relative';
    main.appendChild(wrap);

    function sync() {
      var cur = -1;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-selected')) { cur = i; break; }
      }
      for (var j = 0; j < wrap.children.length; j++) {
        wrap.children[j].classList.toggle('is-active', j === cur);
      }
    }

    var mo = new MutationObserver(sync);
    slides.forEach(function (sl) {
      mo.observe(sl, { attributes: true, attributeFilter: ['class'] });
    });
    sync();
  }

  function boot(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    [].forEach.call(root.querySelectorAll(SLIDER), build);
    if (root !== document && root.matches && root.matches(SLIDER)) build(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  var t = null;
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { boot(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* ---------- Part B: collection-card dot sync on touch swipe ----------
   On touch devices the CSS turns .pk-card-slider__track into a native
   scroll-snap strip. pk-card-slider.js only updates its dots from arrow
   clicks, which no longer exist there, so the active dot is derived from
   scroll position instead. Pointer devices are skipped entirely - their
   arrows and pk-card-slider.js behaviour are untouched. */
(function () {
  if (window.__pkCardSwipeInit) return;
  window.__pkCardSwipeInit = true;

  var TOUCH = window.matchMedia('(hover: none), (max-width: 767px)');

  function wire(root) {
    if (!root || root.dataset.pkSwipeDots === '1') return;
    var track = root.querySelector('[data-pk-track]');
    var dots = root.querySelectorAll('[data-pk-dot]');
    if (!track || !dots.length) return;
    root.dataset.pkSwipeDots = '1';

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i < 0) i = 0;
        if (i > dots.length - 1) i = dots.length - 1;
        for (var j = 0; j < dots.length; j++) {
          dots[j].classList.toggle('is-active', j === i);
        }
      });
    }, { passive: true });
  }

  function boot(scope) {
    if (!TOUCH.matches) return;
    var root = scope && scope.querySelectorAll ? scope : document;
    [].forEach.call(root.querySelectorAll('[data-pk-slider]'), wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  var t2 = null;
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function () {
      clearTimeout(t2);
      t2 = setTimeout(function () { boot(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (TOUCH.addEventListener) {
    TOUCH.addEventListener('change', function () { boot(); });
  }
})();